import BuildingIcon from '../../../icons/building.svg'

export const BUILDING_SEARCH_ITEM_ICON = { Icon: BuildingIcon }
